import qs from 'qs';

import client from '../../client';
import type {
  IAddModlinkParams,
  IDeleteModLinkParams,
  IEditModLinkParams,
  IGetDeviceInfoParams,
  IGetDeviceListExcelDownloadParams,
  IGetDistributorCompanyParams,
  IModlinkInternalList,
  IRegistrationModLinkParams,
  IUpdateDeviceInfoParams,
  TDeleteDeviceParams,
  TUploadDeviceExcelParams,
} from './types';

export const deviceManagementApis = {
  // MAIN
  RegistrationModLink: (data: IRegistrationModLinkParams) =>
    client.post('/modlink', data),
  deleteModLink: (data: IDeleteModLinkParams) => client.delete('/modlink', { data }), // delete method requires a wrapped body.
  editModLink: (data: IEditModLinkParams) => client.put(`/modlink/${data.id}`, data.data),
  downloadExcel: () => client.get('/device/download-excel', { responseType: 'blob' }),
  uploadExcel: (formData: TUploadDeviceExcelParams) =>
    client.post('/device/upload-excel', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 전체 디바이스 목록
  getTotalDeviceList: (data: IModlinkInternalList) =>
    client.get('/device', {
      params: { ...data },
      paramsSerializer: {
        serialize: function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
      },
    }),
  getDeviceListExcelDownload: (data: IGetDeviceListExcelDownloadParams) =>
    client.get('/device/download-list-excel', { params: data, responseType: 'blob' }),
  getDeviceAggregation: () => client.get('/device/aggregation'),
  getDistributorCompany: (data: IGetDistributorCompanyParams) =>
    client.get(`/device/distributor-company`, { params: data }),
  // 모드링크 등록
  addModlink: (data: IAddModlinkParams) => client.post('/device', data),
  // 모드링크 정보 조회
  getDeviceInfo: (data: IGetDeviceInfoParams) => client.get(`/device/${data.id}`),
  // 모드링크 정보 수정
  updateDeviceInfo: (data: IUpdateDeviceInfoParams) => client.put(`/device/${data.id}`, data.data),
  deleteDevice: (data: TDeleteDeviceParams) => client.delete(`/device?macs=${data.join(',')}`),
};
